import { StepLengthUtil } from "./step-length-util";

export class StepCounter {
    private totalDistance: number = 0;
    private partDistance: number = 0;

    private startStep: number = 0;
    private endStep: number = 0;

    private startPoint: number = 0;
    private endPoint: number = 0;

    //total step counter for the whole run
    private totalStepCount: number = 0;

    //part step count is used to detect how many steps were made when GPS stops working,
    //it's counted untill GPS starts working again
    private partStepCount: number = 0;


    private myStep: number = StepLengthUtil.AVERAGE_STEP;

    increaseStepCount() {
        this.totalStepCount++;
    }

    getTotalStepCount(): number {
        return this.totalStepCount;
    }

    setTotalStepCount(n: number) {
        this.totalStepCount = n;
    }

    getPartStepCount(): number {
        return this.partStepCount;
    }

    getPartDistance(): number {
        return this.partDistance;
    }

    getTotalDistance(): number {
        return this.totalDistance;
    }

    getStartStep(): number {
        return this.startStep;
    }

    getEndStep(): number {
        return this.endStep;
    }

    getMyStep(): number {
        return this.myStep;
    }

    setMyStep(s) {
        this.myStep = s;
    }

    setPartStepCount(s) {
        this.partStepCount = s;
    }

    setPartDistance(d: number) {
        this.partDistance = d;
    }

    setTotalDistance(d: number) {

        this.totalDistance = d;
    }

    setStartStep(startStep) {
        this.startStep = startStep;
    }

    setEndStep(endStep) {
        this.endStep = endStep;
    }

}